<div *ngIf="loader==false" class="col-12 col-sm-12 col-md-12 col-xl-12 col-lg-12 px-0">

    <div id="webDeskSidebarComponent"
         [ngClass]="{'col-1':!sidebarState,'col-sm-1':!sidebarState, 'col-md-2':!sidebarState,'col-lg-2':!sidebarState, 'col-xl-2':!sidebarState}"
         [ngStyle]="{'width': !sidebarState ? 'auto':'0px', 'display': !sidebarState ? 'auto':'none'}"
         class=" no-padding">
    </div>
    <div id="webDeskKanbanComponent"
         [ngClass]="{'col-11':!sidebarState,'col-sm-11':!sidebarState,'col-md-10':!sidebarState,'col-lg-10':!sidebarState,'col-xl-10':!sidebarState,
    'col-12':sidebarState,'col-sm-12':sidebarState,'col-md-12':sidebarState,'col-lg-12':sidebarState,'col-xl-12':sidebarState
    }"
         class="vh-100 full-width no-padding">


        <ng-scrollbar track="all" pointerEventsMethod="scrollbar">
            <main class="page-content pt-2">
                <div id="overlay" class="overlay"></div>
                <div class="container-fluid">


                    <div class="well-done-container">
                        <div class="col-md-8">
                            <app-my-web-desk-header></app-my-web-desk-header>
                            <div id="kanban" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <app-my-web-desk-content></app-my-web-desk-content>
                            </div>
                        </div>
                        <div class="col-md-4" style="margin-top: 5%;">
                            <app-my-web-desk-sidebar></app-my-web-desk-sidebar>
                        </div>
                    </div>
                </div>
            </main>
        </ng-scrollbar>

    </div>

</div>
